export const esd = {
  id: 4,
  name: "Enterprise & Supplier Development",
  slug: "esd",
  status: "on track",
  description:
    "Preferential procurement, enterprise development, and supplier development initiatives",
  deadline: "31 Jan 2026",
  current_points: 35.5,
  total_points: 44,
  target: 40,
  workflow_completed: 3,
  workflow_total: 7,
  icon: "fas fa-handshake",
  theme: { gradientFrom: "#f59e0b", gradientTo: "#f97316" },
  steps: [
    {
      id: "esd-1",
      title: "Compile Supplier Database",
      description: "Extract complete supplier list with annual spend from procurement system",
      status: "completed",
      due: "05 Jan 2026",
      owner_initials: "PT",
      owner_name: "Procurement Team",
      owner_role: "Supply Chain",
      owner_email: "procurement.team@company.co.za",
      owner_number: "+27 86 567 8901",
      owner_role_desc: "Manages procurement and supplier relationships",
      required_documents: ["Supplier Master List", "Annual Spend Report"],
    },
    {
      id: "esd-2",
      title: "Collect Supplier BEE Certificates",
      description: "Request and verify valid BEE certificates from all qualifying suppliers",
      status: "in_progress",
      due: "18 Jan 2026",
      owner_initials: "AS",
      owner_name: "Ayanda Sithole",
      owner_role: "Procurement Manager",
      owner_email: "ayanda.sithole@company.co.za",
      owner_number: "+27 87 678 9012",
      owner_role_desc: "Oversees supplier management and BEE verification",
      required_documents: ["Supplier BEE Certificates", "SANAS Verification"],
    },
    {
      id: "esd-3",
      title: "Classify Suppliers",
      description:
        "Classify suppliers by BEE level and ownership status",
      status: "completed",
      due: "15 Jan 2026",
      owner_initials: "AS",
      owner_name: "Ayanda Sithole",
      owner_role: "Procurement Manager",
      required_documents: ["Supplier Classification Sheet"],
    },
    {
      id: "esd-4",
      title: "Document Supplier Development Support",
      description:
        "Compile evidence of supplier development contributions",
      status: "pending",
      due: "22 Jan 2026",
      owner_initials: "ZN",
      owner_name: "Zanele Nxumalo",
      owner_role: "ED Coordinator",
      required_documents: ["SD Support Evidence", "Payment Proof"],
    },
    {
      id: "esd-5",
      title: "Calculate ESD Scores",
      description:
        "Calculate ED and SD spend and scorecard points",
      status: "pending",
      due: "28 Jan 2026",
      owner_initials: "LZ",
      owner_name: "Lindiwe Zulu",
      owner_role: "BEE Consultant",
      required_documents: ["ESD Calculation Workbook"],
    },
    {
      id: "esd-6",
      title: "Prepare ESD Summary",
      description:
        "Prepare ESD score summary for verification",
      status: "pending",
      due: "30 Jan 2026",
      owner_initials: "LZ",
      owner_name: "Lindiwe Zulu",
      owner_role: "BEE Consultant",
      required_documents: ["ESD Summary Report"],
    },
    {
      id: "esd-7",
      title: "Submit ESD Pack",
      description:
        "Submit complete ESD evidence pack for verification",
      status: "pending",
      due: "31 Jan 2026",
      owner_initials: "JD",
      owner_name: "John Dlamini",
      owner_role: "BEE Manager",
      required_documents: ["Complete ESD Pack"],
    },
  ],
};
